import { parseAttributeName } from "@gr-exports/async/attribute-parser";
import type { AttributeDefaultValue, AttributeEventValue } from "../../attribute-parser/nameParser";
import { DATA_BASE_ATTR } from "./elements";
import { dataContainerParam, parserParametersOptions, primitiveParams } from "./params";
import { loggerScope } from "./utils.js";

const log = loggerScope.scope("attributes");

/**
 *
 *
 *
 *
 *
 *
 */
export function getTrackingAttributes(
  elementToTrack: HTMLElement,
): (AttributeDefaultValue | AttributeEventValue)[] {
  const attrs = elementToTrack
    .getAttributeNames()
    .map((a) => parseAttributeName(DATA_BASE_ATTR, a, dataContainerParam, parserParametersOptions))
    .filter(Boolean);
  return attrs;
}

/**
 *
 */
export const getTrackingAttributeByName = (
  attrs: (AttributeDefaultValue | AttributeEventValue)[],
  name: string,
): AttributeDefaultValue | AttributeEventValue | undefined => {
  return attrs.find((a) => a[1] === name);
};

/**
 *
 *
 *
 *
 *
 *
 *
 */
export function getLockInitTokenFromElement(
  elementToTrack: HTMLElement,
  attrs: (AttributeDefaultValue | AttributeEventValue)[],
): string | HTMLElement | undefined {
  const lockInit = getTrackingAttributeByName(attrs, primitiveParams[6]);
  if (!lockInit) return undefined;

  const lockInitToken = elementToTrack.getAttribute(lockInit[0])!;
  if (!lockInitToken) return elementToTrack;

  return lockInitToken;
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function getTrackingEventsFromElement(
  elementToTrack: HTMLElement,
  attrs: (AttributeDefaultValue | AttributeEventValue)[],
): string[] {
  const track = getTrackingAttributeByName(attrs, primitiveParams[5]);

  let accumulator: string[];
  if (track) {
    const eventsString = elementToTrack.getAttribute(track[0])!;
    accumulator = eventsString.split(",").map((e) => e.trim());
  } else {
    accumulator = attrs.filter((e) => typeof e[3] === "string").map((e) => e[3] as string);
  }

  log.debug("Extracted events from element", { events: accumulator });
  return Array.from(new Set(accumulator));
}
